// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"330cf32f","79":"909b4c9c","135":"a153f9c3","243":"fade30b8","259":"356ad7a9","426":"a7f650eb","511":"f0ff3077","915":"d9392b57"}[chunkId] + ".chunk.js";
};